import DraftAutosave from './draftAutosave';
import DraftAutosave2 from './draftAutosave2';

export const initAutosaveForForm = (ctx, { formId, fields, expireMs }) => {
  const uid = ctx.props?.authReducer?.uid;
  const type = ctx.props?.match?.params?.type;
  const timepoint = ctx.props?.match?.params?.timepoint;
  if (!uid || !type || typeof timepoint === 'undefined') return null;

  const draft = new DraftAutosave({
    uid, type, timepoint, formId, fields, expireMs,
    getStatus: () => ctx.state.status,
    setState: (s) => ctx.setState(s),
    getState: () => ctx.state,
    coerceIn: (name, v) => {
      // Default: return as-is
      if (name === 'medications' && Array.isArray(v)) {
        const numeric = ctx.numericKeysInMedications || new Set();
        return v.map(item => Object.fromEntries(Object.entries(item).map(([k,val]) => {
          if (numeric.has(k)) return [k, Number(val)];
          return [k, val];
        })));
      }
      if (name === 'new_medications' && Array.isArray(v)) {
        const numeric = ctx.numericKeysInNewMeds || new Set();
        return v.map(item => Object.fromEntries(Object.entries(item).map(([k,val]) => {
          if (numeric.has(k)) return [k, Number(val)];
          return [k, val];
        })));
      }
      return v;
    },
  });

  draft.hydrate();   // pull saved arrays into state
  draft.attach();    // save on unload
  return draft;
};

export const initAutosaveForForm2 = (ctx, { formId, fields, expireMs }) => {
  const uid = ctx.props?.authReducer?.uid;
  if (!uid) return null;

  const draft = new DraftAutosave2({
    uid, formId, fields, expireMs,
    getStatus: () => ctx.state.status,
    setState: (s) => ctx.setState(s),
    getState: () => ctx.state,
    coerceIn: (name, v) => {
      // Default: return as-is
      if (name === 'medications' && Array.isArray(v)) {
        const numeric = ctx.numericKeysInMedications || new Set();
        return v.map(item => Object.fromEntries(Object.entries(item).map(([k,val]) => {
          if (numeric.has(k)) return [k, Number(val)];
          return [k, val];
        })));
      }
      if (name === 'new_medications' && Array.isArray(v)) {
        const numeric = ctx.numericKeysInNewMeds || new Set();
        return v.map(item => Object.fromEntries(Object.entries(item).map(([k,val]) => {
          if (numeric.has(k)) return [k, Number(val)];
          return [k, val];
        })));
      }
      return v;
    },
  });

  draft.hydrate();   // pull saved arrays into state
  draft.attach();    // save on unload
  return draft;
};

export const ensureAutosaveInitialized = (ctx, draftRefName, config, prevProps) => {
  if (ctx[draftRefName]) return;
  const prevUid = prevProps?.authReducer?.uid;
  const currUid = ctx.props?.authReducer?.uid;
  if (currUid && currUid !== prevUid) {
    ctx[draftRefName] = initAutosaveForForm(ctx, config);
  }
};

export const detachAutosave = (ctx, draftRefName) => {
  if (ctx[draftRefName]) ctx[draftRefName].detach();
};
